export const FILES_PER_PAGE = 15;
